var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3246 4.9323C10.751 3.17589 13.249 3.17589 13.6754 4.9323C13.9508 6.06692 15.2507 6.60537 16.2478 5.99784C17.7913 5.05738 19.5576 6.82369 18.6172 8.36718C18.0096 9.36425 18.5481 10.6642 19.6827 10.9396C21.4391 11.366 21.4391 13.864 19.6827 14.2904C18.5481 14.5658 18.0096 15.8657 18.6172 16.8628C19.5576 18.4063 17.7913 20.1726 16.2478 19.2321C15.2507 18.6246 13.9508 19.1631 13.6754 20.2977C13.249 22.0541 10.751 22.0541 10.3246 20.2977C10.0492 19.1631 8.74926 18.6246 7.75219 19.2321C6.2087 20.1726 4.44239 18.4063 5.38285 16.8628C5.99038 15.8657 5.45193 14.5658 4.31731 14.2904C2.5609 13.864 2.5609 11.366 4.31731 10.9396C5.45193 10.6642 5.99037 9.36425 5.38285 8.36718C4.44239 6.82369 6.2087 5.05738 7.75219 5.99784C8.74926 6.60536 10.0492 6.06692 10.3246 4.9323Z",
    stroke: "#9DA3AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.615C15 14.2718 13.6569 15.615 12 15.615C10.3431 15.615 9 14.2718 9 12.615C9 10.9581 10.3431 9.61499 12 9.61499C13.6569 9.61499 15 10.9581 15 12.615Z",
    stroke: "#9DA3AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.f704636d104778e741fd069171b72f13.svg";
export { ForwardRef as ReactComponent };